import { Link } from "react-router-dom";
import AfricaNavbar from "@/components/AfricaNavbar";
import AfricaFooter from "@/components/AfricaFooter";
import { Button } from "@/components/ui/button";
import {
  Car, Home, Package, Factory, Zap, Wheat, Gem,
  Building2, UserCheck, ClipboardCheck,
  Handshake, Ship, FileText, Fingerprint,
  ChevronRight,
} from "lucide-react";

const GROUPS = [
  { title: "Asset verification", body: "Independent verification of physical assets, from pre-purchase inspection to lifecycle passport.", items: [
    { Icon: Car,     name: "AutoVerify™",           avail: "Live · Zimbabwe" },
    { Icon: Home,    name: "PropertyVerify™",       avail: "Live · Zimbabwe" },
    { Icon: Package, name: "EquipmentVerify™",      avail: "Enterprise · pilot" },
    { Icon: Factory, name: "MachineryVerify™",      avail: "Enterprise · pilot" },
    { Icon: Gem,     name: "MiningAssetVerify™",    avail: "Enterprise engagement" },
    { Icon: Zap,     name: "EnergyAssetVerify™",    avail: "Enterprise engagement" },
    { Icon: Wheat,   name: "AgricultureVerify™",    avail: "Coming soon" },
    { Icon: Gem,     name: "LuxuryAssetVerify™",    avail: "Coming soon" },
  ]},
  { title: "Organisation & transaction verification", body: "Verify counterparties, transactions and cross-border trade before you commit.", items: [
    { Icon: Building2,      name: "BusinessVerify™",      avail: "Enterprise · pilot" },
    { Icon: UserCheck,      name: "SupplierVerify™",      avail: "Enterprise · pilot" },
    { Icon: ClipboardCheck, name: "ContractorVerify™",    avail: "Enterprise engagement" },
    { Icon: Handshake,      name: "TransactionVerify™",   avail: "Enterprise · pilot" },
    { Icon: Ship,           name: "CustomsVerify™",       avail: "Enterprise engagement" },
    { Icon: Ship,           name: "TradeVerify™",         avail: "Enterprise engagement" },
    { Icon: FileText,       name: "DocumentVerify™",      avail: "Coming soon" },
    { Icon: Fingerprint,    name: "IdentityVerify™",      avail: "Coming soon" },
  ]},
];

export default function AfricaServices() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <AfricaNavbar />
      <section className="max-w-[1500px] mx-auto px-6 py-16 lg:py-24">
        <div className="max-w-[820px]">
          <div className="kicker text-white/60">Verification services</div>
          <h1 className="display text-4xl lg:text-6xl mt-3 leading-[1.02]">A verification service for every high-value decision.</h1>
          <p className="mt-5 text-white/70 text-[15px] leading-[1.75]">
            Every service is built on the same shared trust engine — Trust Score, evidence vault,
            digital certificates, audit trails and Digital Passports. Country availability varies as
            regulatory data partnerships come online.
          </p>
        </div>

        {GROUPS.map((g) => (
          <div key={g.title} className="mt-14">
            <div className="max-w-[820px]">
              <div className="mono text-[10.5px] uppercase tracking-[0.22em] text-[#B08C4A]">Service family</div>
              <h2 className="display text-3xl mt-2">{g.title}</h2>
              <p className="text-white/70 text-[14.5px] mt-3 leading-[1.7]">{g.body}</p>
            </div>
            <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-4 gap-3">
              {g.items.map((it) => (
                <div key={it.name} className="border border-white/10 bg-white/[0.02] p-5" data-testid={`africa-service-${it.name.replace(/[™\s]/g,'').toLowerCase()}`}>
                  <it.Icon className="h-5 w-5 text-[#B08C4A]" />
                  <div className="mt-4 text-[15px] font-semibold">{it.name}</div>
                  <div className="mono text-[10px] uppercase tracking-widest text-white/50 mt-2">{it.avail}</div>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="mt-16 border border-white/10 bg-white/[0.02] p-6 lg:p-8 flex flex-col lg:flex-row items-start lg:items-center gap-6">
          <div className="flex-1">
            <div className="kicker text-white/60">Ready to verify?</div>
            <h3 className="text-2xl font-semibold mt-2">Speak to our enterprise team.</h3>
            <p className="text-[13.5px] text-white/70 mt-2">Every service is available under enterprise engagement — even if it is not yet in country-wide production. We deliver bespoke verification programmes for banks, insurers, governments and industrial operators.</p>
          </div>
          <Link to="/africa/enterprise#request"><Button size="lg" className="bg-[#B08C4A] hover:bg-[#8f6f34] text-black">Request Enterprise Verification <ChevronRight className="ml-1.5 h-4 w-4" /></Button></Link>
        </div>
      </section>
      <AfricaFooter />
    </div>
  );
}
